import { createAction } from '@reduxjs/toolkit';
//import { type DailyDataGraph } from '../../../VectorFlow/types/MTA';

const actions = {
    SAVE_ANALYTICS_DATA: createAction<object>("SAVE_ANALYTICS_DATA"),
    DAYWISE_COVERAGE_ANALYTICS: createAction<object>("DAYWISE_COVERAGE_ANALYTICS"),
    PROCPLANNING_ANALYTICS: createAction<object>("PROCPLANNING_ANALYTICS"),
    RESOURCE_UTIL_ANALYTICS: createAction<object>("RESOURCE_UTIL_ANALYTICS"),
    APPLIED_FILTERS: createAction<object>("APPLIED_FILTERS"),
    BM_REPORT_ANALYTICS: createAction<object>("BM_REPORT_ANALYTICS"),
    SET_TASK_PENDING_SELECTED: createAction<any>("SET_TASK_PENDING_SELECTED"),
    SET_EDITABLE_MAJ_ROW: createAction<any>("SET_EDITABLE_MAJ_ROW"),
    SET_EDITABLE_MIN_ROW: createAction<any>("SET_EDITABLE_MIN_ROW"),
    SET_POOGI_INITIAL_DATA: createAction<any>("SET_POOGI_INITIAL_DATA"),
    SET_BUFFER_INITIAL_DATA: createAction<any>("SET_BUFFER_INITIAL_DATA"),
    SET_BUFFER_MODIFY_DATA: createAction<any>("SET_BUFFER_MODIFY_DATA"),
    SET_CALENDAR_INITIAL_DATA: createAction<any>("SET_CALENDAR_INITIAL_DATA"),
    SET_CALENDAR_MODIFY_DATA: createAction<any>("SET_CALENDAR_MODIFY_DATA"),
    SET_CCR_INITIAL_DATA: createAction<any>("SET_CCR_INITIAL_DATA"),
    SET_CCR_MODIFY_DATA: createAction<any>("SET_CCR_MODIFY_DATA"),
    SET_TASK_PENDING_ROW_DATA: createAction<any>("SET_TASK_PENDING_ROW_DATA"),
    SET_POOGI_MODIFY_DATA: createAction<any>("SET_POOGI_MODIFY_DATA"),
    RESET_MTO_STATE: createAction("RESET_MTO_STATE"),
    SET_EDIT_STATUS: createAction("SET_EDIT_STATUS")
    // UPDATE_DAILY_DATA: createAction<DailyDataGraph>("UPDATE_DAILY_DATA"),
    // TOGGLE_GRAPH_MODAL: createAction<boolean>("TOGGLE_GRAPH_MODAL"),
    // TOGGLE_NORM_CHANGE_HISTORY_TABLE: createAction<boolean>("TOGGLE_NORM_CHANGE_HISTORY_TABLE"),
    // UPDATE_GRID_STATE:createAction<any>(" UPDATE_GRID_STATE"),
    // UPDATE_PLANNING_DATA:createAction<any>("UPDATE_PLANNING_DATA")
}


export const {
    SAVE_ANALYTICS_DATA,
    DAYWISE_COVERAGE_ANALYTICS,
    PROCPLANNING_ANALYTICS,
    RESOURCE_UTIL_ANALYTICS,
    BM_REPORT_ANALYTICS,
    SET_TASK_PENDING_SELECTED,
    APPLIED_FILTERS,
    SET_EDITABLE_MAJ_ROW,
    SET_EDITABLE_MIN_ROW,
    SET_POOGI_INITIAL_DATA,
    SET_BUFFER_INITIAL_DATA,
    SET_BUFFER_MODIFY_DATA,
    SET_CALENDAR_INITIAL_DATA,
    SET_CALENDAR_MODIFY_DATA,
    SET_TASK_PENDING_ROW_DATA,
    SET_CCR_INITIAL_DATA,
    SET_CCR_MODIFY_DATA,
    SET_POOGI_MODIFY_DATA,
    RESET_MTO_STATE,
    SET_EDIT_STATUS
} = actions;